import { useCallback } from 'react';
import { usePermissions } from './usePermissions';

/**
 * Hook للتحقق من صلاحيات تقرير كميات إعادة الطلب
 * يوفر دوال للتحقق من الصلاحيات المختلفة لصفحة تقرير كميات إعادة الطلب
 */
export const useReorderQuantitiesReportPermissions = () => {
  const { hasPermission } = usePermissions();

  // التحقق من صلاحية الوصول إلى صفحة التقرير
  const hasAccessPermission = useCallback(() => {
    return hasPermission('reports', 'reorder-quantities-report', 'view_page');
  }, [hasPermission]);

  // التحقق من صلاحية تصدير الإكسل
  const hasExportPermission = useCallback(() => {
    return hasPermission('reports', 'reorder-quantities-report', 'export_excel');
  }, [hasPermission]);

  // التحقق من صلاحية الطباعة
  const hasPrintPermission = useCallback(() => {
    return hasPermission('reports', 'reorder-quantities-report', 'print');
  }, [hasPermission]);

  // التحقق من صلاحية عرض البيانات
  const hasViewPermission = useCallback(() => {
    return hasPermission('reports', 'reorder-quantities-report', 'view');
  }, [hasPermission]);

  return {
    hasAccessPermission,
    hasExportPermission,
    hasPrintPermission,
    hasViewPermission
  };
};